"use client";
import styles from "../css/CollectionModal.module.css";

export default function CollectionModal({ isOpen, onClose, collectionData, activeFilter, onComplete }) {
  if (!isOpen || !collectionData) return null;

  const computeOverdueText = () => {
    try {
      // Expecting DD/MM/YYYY in sample data. Fallback to raw if parsing fails.
      const [dd, mm, yyyy] = (collectionData.date || "").split("/").map((x) => parseInt(x, 10));
      if (!dd || !mm || !yyyy) return "Overdue";
      const scheduled = new Date(yyyy, mm - 1, dd);
      const now = new Date();
      const diffDays = Math.max(1, Math.ceil((now - scheduled) / (1000 * 60 * 60 * 24)));
      return `${diffDays} ${diffDays === 1 ? "day" : "days"} overdue`;
    } catch {
      return "Overdue";
    }
  };

  const getStatusBadge = () => {
    if (collectionData.status === "overdue" || activeFilter === "Overdue") {
      return <div className={styles.overdueBadge}>{computeOverdueText()}</div>;
    }
    return null;
  };

  const getActionButton = () => {
    // Show for Awaiting and Overdue; hide for Collected
    const showButton = activeFilter === "Awaiting" || activeFilter === "Overdue";
    if (!showButton) return null;
    return (
      <button className={styles.collectedButton} onClick={() => onComplete && onComplete(collectionData.id)}>
        Collected
      </button>
    );
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeButton} onClick={onClose}>
          ×
        </button>

        {collectionData.id && (
          <h2 className={styles.modalTitle}>{collectionData.id}</h2>
        )}

        {collectionData.collectedDate && (
          <p className={styles.collectedInfo}>
            Collected: {collectionData.collectedDate}
          </p>
        )}

        {getStatusBadge()}

        <div className={styles.detailsContainer}>
          <div className={styles.detailRow}>
            <div className={styles.iconContainer}>
              <svg
                className={styles.icon}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
            </div>
            <span className={styles.detailText}>{collectionData.patient}</span>
          </div>

          <div className={styles.detailRow}>
            <div className={styles.iconContainer}>
              <svg
                className={styles.icon}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
              </svg>
            </div>
            <span className={styles.detailText}>{collectionData.date}</span>
          </div>

          <div className={styles.detailRow}>
            <div className={styles.iconContainer}>
              <svg
                className={styles.icon}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <circle cx="12" cy="12" r="10" />
                <polyline points="12,6 12,12 16,14" />
              </svg>
            </div>
            <span className={styles.detailText}>
              {collectionData.scheduledTime}
            </span>
          </div>

          <div className={styles.detailRow}>
            <div className={styles.iconContainer}>
              <svg
                className={styles.icon}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                <line x1="3" y1="6" x2="21" y2="6" />
                <path d="M16 10a4 4 0 0 1-8 0" />
              </svg>
            </div>
            <span className={styles.detailText}>{collectionData.items}</span>
          </div>

          <div className={styles.detailRow}>
            <div className={styles.iconContainer}>
              <span className={styles.currencyIcon}>R</span>
            </div>
            <span className={styles.detailText}>{collectionData.amount}</span>
          </div>

          <div className={styles.detailRow}>
            <div className={styles.iconContainer}>
              <svg
                className={styles.icon}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
                <line x1="1" y1="10" x2="23" y2="10" />
              </svg>
            </div>
            <span className={styles.detailText}>
              {collectionData.paymentType}
            </span>
          </div>
        </div>

        {getActionButton()}
      </div>
    </div>
  );
}
